import { render, staticRenderFns } from "./PalletRackConfigurator.vue?vue&type=template&id=65f0c333"
import script from "./PalletRackConfigurator.vue?vue&type=script&lang=js"
export * from "./PalletRackConfigurator.vue?vue&type=script&lang=js"
import style0 from "./PalletRackConfigurator.vue?vue&type=style&index=0&id=65f0c333&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports